import React from 'react';
import { Link } from 'react-router-dom';
import { SprayCanIcon, Wrench, AlertTriangle } from 'lucide-react';
export function QuickActionCTAs() {
  return <div className="mb-8" data-id="element-541">
      <h2 className="text-sm font-semibold text-foreground mb-3" data-id="element-542">
        Azioni rapide
      </h2>
      <div className="grid grid-cols-3 gap-3" data-id="element-543">
        {/* Pulizie */}
        <Link to="/pulizie" className="bg-white border border-border rounded-xl p-3 flex flex-col items-center text-center gap-2 hover:bg-muted/50 transition-colors" data-id="element-544">
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center" data-id="element-545">
            <SprayCanIcon size={18} className="text-foreground" data-id="element-546" />
          </div>
          <div data-id="element-547">
            <div className="font-medium text-foreground mb-0.5 text-sm" data-id="element-548">
              Pulizie
            </div>
            <div className="text-xs font-medium leading-tight text-[#FF4080]" data-id="element-549">
              3 condivisibili
            </div>
          </div>
        </Link>

        {/* Manutenzione */}
        <Link to="/messaggi" className="bg-white border border-border rounded-xl p-3 flex flex-col items-center text-center gap-2 hover:bg-muted/50 transition-colors" data-id="element-550">
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center" data-id="element-551">
            <Wrench size={18} className="text-foreground" data-id="element-552" />
          </div>
          <div data-id="element-553">
            <div className="font-medium text-foreground mb-0.5 text-sm" data-id="element-554">
              Manutenzione
            </div>
            <div className="text-xs font-medium leading-tight text-[#FF4080]" data-id="element-555">
              1 gruppo attivo
            </div>
          </div>
        </Link>

        {/* Segnalazioni */}
        <Link to="/messaggi" className="bg-white border border-border rounded-xl p-3 flex flex-col items-center text-center gap-2 hover:bg-muted/50 transition-colors" data-id="element-556">
          <div className="w-9 h-9 rounded-full bg-muted flex items-center justify-center" data-id="element-557">
            <AlertTriangle size={18} className="text-foreground" data-id="element-558" />
          </div>
          <div data-id="element-559">
            <div className="font-medium text-foreground mb-0.5 text-sm" data-id="element-560">
              Segnalazioni
            </div>
            <div className="text-xs font-medium leading-tight text-[#FF4080]" data-id="element-561">
              2 aperte
            </div>
          </div>
        </Link>
      </div>
    </div>;
}